import React from 'react';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import {motion} from 'framer-motion';
import {MainBtnVariants} from '../animations/MainPageAnims';

function TitleBtn({content, link="", onClick}) {
  const navigate  = useNavigate();
  // const clickHandler = ()=>{
  //   scrolled = true;
  //   if(link==="back") {
  //     navigate(-1);
  //   }else{
  //     navigate(link);
  //   }
  // }

  return (
    <BtnContainer>
      <Btn
      variants={MainBtnVariants} initial="initial" animate="animate"
      onClick={onClick} >{content}</Btn>
    </BtnContainer>
  );
}

const BtnContainer = styled.div`
  overflow: hidden;
  position: relative;
  transition: all 0.8s ease;
  margin-top: 2rem;
  /* border: 2px solid white; */
  &:hover{
    transform: translate(0px, -10%);
  }
  `;

const Btn= styled(motion.button)`
    background-color: var(--secondary);
    font-size: 1rem;
    padding: 1.1rem 1.6rem;
    border: none;
    border-radius: 35px;
    color: var(--white);
    font-weight: bold;
    letter-spacing: 0.1em;
    align-self: flex-start;
    cursor: pointer;

`;

export default TitleBtn;